@if (!contentLoaded) {
  <app-content-loader></app-content-loader>
}
@if (contentLoaded) {
  <div class="step-container columns is-desktop">
    <app-aside-bar
      [showEvenWithoutStatement]="false"
      [statement]="statement"
      [isNested]="isNested"
      [isBusiness]="isBusiness"
      [workFlowController]="workFlowController"
    ></app-aside-bar>

    <div class="premium-income content">
      <h1 class="title_42 premium-income__title">{{ titleKey | translate }}</h1>

      <p class="premium-income__description">
        <span [innerHTML]="descriptionKey | translate"></span>
        @if (shouldShowDescriptionTooltip) {
          <app-more-info-tooltip
            class="premium-income__description-tooltip"
            [message]="descriptionTooltipMessageKey"
            [titleTooltip]="descriptionTooltipTitleKey"
          ></app-more-info-tooltip>
        }
      </p>

      @if (isSelectionStep) {
        <app-select-buttons [buttons]="premiumIncomeSelectionButtons" [extraContainerClasses]="'p-0'"></app-select-buttons>
      } @else {
        @for (entry of entries; track entry; let i = $index) {
          <div class="premium-income__entry">
            <div class="premium-income__entry-header">
              <h3 class="premium-income__entry-title" #entryTitle>
                {{ sectionLabelKey | translate }} {{ i + 1 }}
              </h3>
              <button type="button" class="premium-income__entry-delete" (click)="removeEntry(i)">
                <img src="../../../assets/svg/del_icon.svg" alt="delete" />
              </button>
            </div>

            <div class="premium-income__field">
              <label>{{ nameLabelKey | translate }}</label>
              <input type="text" [(ngModel)]="entry.name" [placeholder]="namePlaceholderKey | translate" maxlength="100" />
            </div>

            <div class="premium-income__info-box">
              <div class="premium-income__info-icon">
                <img src="../../../assets/svg/tooltip_icon.svg" alt="info" />
              </div>
              <div class="premium-income__info-content" [innerHTML]="infoKey | translate"></div>
            </div>

            <div class="premium-income__upload-wrap">
              <label class="premium-income__upload-btn">
                <input type="file" accept="application/pdf" multiple (change)="onFilesSelected($event, entry)" />
                {{ "PREMIUM_INCOME.COMMON.ATTACH_FILE" | translate }}
              </label>

              @if (entry.existingFiles.length > 0 || entry.newFiles.length > 0) {
                <div class="premium-income__files-title">{{ "PREMIUM_INCOME.COMMON.ADDED_ATTACHMENTS" | translate }}</div>
                <ul class="premium-income__files-list">
                  @for (file of entry.existingFiles; track file.id; let fileIndex = $index) {
                    <li>
                      <div class="premium-income__file-name">
                        <i class="fa fa-file-o" aria-hidden="true"></i>
                        <span>{{ getExistingFileName(file) }}</span>
                      </div>
                      <button type="button" class="premium-income__file-delete" (click)="removeExistingFile(entry, fileIndex)">
                        <img src="../../../assets/svg/del_icon.svg" alt="delete" />
                      </button>
                    </li>
                  }

                  @for (file of entry.newFiles; track file; let fileIndex = $index) {
                    <li>
                      <div class="premium-income__file-name">
                        <i class="fa fa-file-o" aria-hidden="true"></i>
                        <span>{{ file.file.name }}</span>
                      </div>
                      <button type="button" class="premium-income__file-delete" (click)="removeNewFile(entry, fileIndex)">
                        <img src="../../../assets/svg/del_icon.svg" alt="delete" />
                      </button>
                    </li>
                  }
                </ul>
              }

              <div class="premium-income__upload-info">
                <span>{{ "PREMIUM_INCOME.COMMON.ONLY_PDF" | translate }}</span>
                <span>{{ "PREMIUM_INCOME.COMMON.MAX_FILE_SIZE" | translate }}</span>
                <span>{{ "PREMIUM_INCOME.COMMON.MAX_FILES" | translate }} {{ maxFilesNumberPerEntry }}</span>
                <span>{{ "PREMIUM_INCOME.COMMON.MAX_PAGES" | translate }}</span>
              </div>
            </div>
          </div>
        }

        <button type="button" class="premium-income__add-entry" (click)="addEntry()">
          <img src="../../../assets/svg/add_new.svg" alt="add" />
          <span>{{ addButtonKey | translate }}</span>
        </button>

        <div class="premium-income__field premium-income__field--textarea">
          <label>{{ additionalInfoLabelKey | translate }}</label>
          <textarea
            [(ngModel)]="additionalInformation"
            [placeholder]="additionalInfoPlaceholderKey | translate"
            maxlength="4000"
          ></textarea>
        </div>
      }
    </div>
  </div>

  <app-tools-bar [statement]="statement" [buttons]="buttons"></app-tools-bar>
}
